// jshint esversion: 8

export default {
  id: null,
  name: null,
  logo: './img/favicon.png'
};
